export const loginScreen = {
  background: {
    width: "100%",
    height: "100vh",
    minHeight: "100%",
    display: "flex",
    justifyContent: "center",
  } as React.CSSProperties,
  loginInput: {
    zIndex: 1,
    display: "flex",
  } as React.CSSProperties,
  rightsText: {
    color: "white",
  },
  lightAppView: {
    backgroundColor: "#f3f0ff",
  },
  darkAppView: {
    backgroundColor: "#1a1535",
  },
  themeSelectorView: {
    position: "fixed",
    top: 0,
    right: 0,
    left: 0,
    height: "60px",
    zIndex: 1100,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginRight: "1rem",
    padding: "0.75rem 1rem",
    gap: 8,
  } as React.CSSProperties,
  themeText: {
    fontSize: "1rem",
    color: "var(--amplify-colors-font-secondary)",
  },
  innerAppView: {
    width: "min(500px, 95%)",
    borderRadius: "20px",
    boxShadow: "0 20px 60px rgba(0,0,0,.08)",
    background: "#fff",
    padding: "2rem",
  },
  loginContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "grid",
    placeItems: "center",
  } as React.CSSProperties,
  fullAppView: {
    minHeight: "100vh",
    display: "flex",
    marginTop: "60px",
    width: "100%",
    flexDirection: "column",
  } as React.CSSProperties,
};
